module.exports = __webpack_public_path__ + "static/img/heat-sink_256.83c6ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heat-sink_256.png
// module id = PBGr
// module chunks = 0